export default "__VITE_ASSET__I77yU890__"